module.exports = __webpack_public_path__ + "static/media/app-03.2cd61a02.png";